"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.excavatorTypes = exports.excavatorReducer = exports.excavatorAction = void 0;
const excavator_component_1 = __importDefault(require("./sub-components/excavator.component"));
const excavator_action_1 = __importDefault(require("./excavator.action"));
exports.excavatorAction = excavator_action_1.default;
const excavator_reducer_1 = __importDefault(require("./excavator.reducer"));
exports.excavatorReducer = excavator_reducer_1.default;
const excavator_types_1 = require("./excavator.types");
Object.defineProperty(exports, "excavatorTypes", { enumerable: true, get: function () { return excavator_types_1.excavatorTypes; } });
exports.default = excavator_component_1.default;
